"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPartialTransferrer = void 0;
var transferer_1 = require("./transferer");
var ContentPartialTransferrer = /** @class */ (function () {
    function ContentPartialTransferrer() {
    }
    ContentPartialTransferrer.toRemote = function (source, sink, totalSize, sourceOffset, sinkOffset, config, transferrerName, token, p) {
        var transferrer = new transferer_1.PartialTransferrer(transferToRemote, config, transferrerName);
        var bytesToUpload = getCount(totalSize, sourceOffset);
        return transferrer.transfer(source, sink, sourceOffset, sinkOffset, bytesToUpload, token, p);
    };
    ContentPartialTransferrer.fromRemote = function (source, sink, totalSize, sourceOffset, sinkOffset, config, transferrerName, token, p) {
        var transferrer = new transferer_1.PartialTransferrer(transferFromRemote, config, transferrerName);
        var bytesToDownload = getCount(totalSize, sourceOffset);
        return transferrer.transfer(source, sink, sourceOffset, sinkOffset, bytesToDownload, token, p);
    };
    return ContentPartialTransferrer;
}());
exports.ContentPartialTransferrer = ContentPartialTransferrer;
function transferToRemote(source, sink, sourceOffset, sinkOffset, count, token) {
    return sink.writePart(source, sourceOffset, sinkOffset, count, token);
}
function transferFromRemote(source, sink, sourceOffset, sinkOffset, count, token) {
    return source.read(sink, sourceOffset, sinkOffset, count, token);
}
function getCount(size, offset) {
    return size - offset;
}
